import { ComponentProps } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { logoWrapperClass } from './Navigation.css';

interface LogoWrapperProps extends ComponentProps<'div'> {
  className?: string;
}

export const LogoWrapper = ({ className, ...props }: LogoWrapperProps) => (
  <div className={getClassNames(logoWrapperClass, className)} {...props} />
);
